import React from "react";
import "./profile.css"
import { useSelector } from "react-redux";


function Profile(){
    const user = useSelector(store => store.user)
    return(
        <div className="profile">

            <div className="profile--pic-Container">
            <i class="fa-solid fa-user"></i>
            </div>
            <hr></hr>
            


            <div className="profile--info">
                <form className="profileForm" onSubmit="">
                    <h1 className="profile--title">Profile Information</h1>

                    <label> username
                        <input 
                            name="username"
                            className="profile--info--field"
                            type="text"
                            value={user.username}/>
                    </label>
                            
                    <hr></hr>
                    <label> firstname
                        <input 
                            name="first_name"
                            className="profile--info--field"
                            type="text"
                            value={user.first_name}/>
                    </label>
                            
                    <hr></hr>
                    <label> lastname
                        <input 
                            name="last_name"
                            className="profile--info--field"
                            type="text"
                            value={user.last_name}/>
                    </label>
                            
                    <hr></hr>
                    <label> email
                        <input
                            name="email"
                            className="profile--info--field"
                            type="email"
                            value={user.email}/>
                    </label>
                           
                    <hr></hr>

                    <h3 className="ProfileDate">Date Joined : {user.date_joined.split("T")[0]}</h3>

                    <button className="profileForm--btn">Update</button>

                </form>

            </div>
        </div>
    )
}

export default Profile